var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#FFF9ED",
    stroke: "#FFBF35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9869 38.3369H41.4832C36.1416 38.3369 30.8045 38.3369 25.4629 38.3369C24.3909 38.3369 23.5406 37.787 23.171 36.8719C22.8013 35.9525 23.0416 34.9275 23.7902 34.2588C24.2707 33.8277 24.8529 33.6649 25.5045 33.6649C28.9932 33.6693 32.4773 33.6649 35.966 33.6649C37.8189 33.6649 39.6719 33.6649 41.5248 33.6649H41.9777C41.5849 33.269 41.2568 32.9391 40.9241 32.6091C40.0693 31.7557 39.2098 30.9066 38.355 30.0532C37.6942 29.3933 37.4631 28.6147 37.6942 27.7348C37.916 26.8946 38.4751 26.3183 39.3623 26.0851C40.2587 25.852 41.0304 26.1071 41.6635 26.7362C43.4748 28.5355 45.2815 30.3391 47.0929 32.1428C47.8322 32.8819 48.5762 33.6209 49.3109 34.36C50.2212 35.2794 50.2351 36.6696 49.3201 37.589C46.8018 40.1229 44.2696 42.6525 41.7466 45.182C40.7578 46.1718 39.427 46.273 38.4381 45.4328C37.4539 44.5969 37.3245 43.11 38.1978 42.1422C38.8217 41.4515 39.5055 40.8136 40.1663 40.1493C40.7485 39.5686 41.3308 38.9923 41.9915 38.3325L41.9869 38.3369Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.d3a6a6bb1de6f0fc3051d752327adfb2.svg";
export { ForwardRef as ReactComponent };